var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBgTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 711,
    viewBox: "0 0 287 711",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M0.738281 532.887H177.994M0.738281 532.887V355.907M0.738281 532.887V710.638H177.994M688.092 532.887V355.907M688.092 532.887H532.204M688.092 532.887V710.638H532.204M89.8174 0.742188H0.738281V89.8343M89.8174 0.742188H133.906M89.8174 0.742188V45.2882M89.8174 89.8343H133.906M89.8174 89.8343V45.2882M89.8174 89.8343V355.907M89.8174 89.8343H45.2778M0.738281 89.8343V134.38M0.738281 89.8343H45.2778M355.249 0.742188V89.8343H266.17M355.249 0.742188H532.204M355.249 0.742188H355.099M266.17 0.742188V89.8343M266.17 0.742188H177.994M266.17 0.742188H355.099M266.17 89.8343H177.994M266.17 89.8343V355.907M177.994 89.8343H133.906M177.994 89.8343V45.2882M177.994 89.8343V134.38M177.994 0.742188H133.906M177.994 0.742188V45.2882M133.906 0.742188V89.8343M133.906 89.8343V178.324M89.8174 45.2882H177.994M0.738281 134.38H177.994M0.738281 134.38V178.324M177.994 134.38V532.887M177.994 532.887H355.099M177.994 532.887V710.638M0.738281 355.907V267.116M0.738281 355.907H89.8174M688.092 355.907V178.324M688.092 355.907H266.17M0.738281 178.324V267.116M0.738281 178.324H45.2778M688.092 178.324V0.742188H532.204M688.092 178.324H133.906M532.204 0.742188V532.887M532.204 532.887H355.099M532.204 532.887V710.638M355.099 532.887V267.116M355.099 532.887V710.638M355.099 0.742188V267.116M266.17 355.907H89.8174M0.738281 267.116H355.099M45.2778 89.8343V178.324M45.2778 178.324H133.906M177.994 710.638H355.099M355.099 710.638H532.204",
    stroke: "url(#paint0_radial_54707_36542)",
    strokeWidth: 0.73909
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4297 171.469V231.335",
    stroke: "url(#paint1_linear_54707_36542)",
    strokeWidth: 0.73909,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.773 89.4297L210.64 89.4297",
    stroke: "url(#paint2_linear_54707_36542)",
    strokeOpacity: 0.6,
    strokeWidth: 0.73909,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.734 45.4609L134.146 45.4609L134.146 18.1146",
    stroke: "url(#paint3_linear_54707_36542)",
    strokeOpacity: 0.6,
    strokeWidth: 0.73909,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.121 375.461V435.327",
    stroke: "url(#paint4_linear_54707_36542)",
    strokeOpacity: 0.2,
    strokeWidth: 0.73909,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54707_36542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.6464 183.667) rotate(1.69967) scale(249.183 422.479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989CA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54707_36542",
    x1: 90.4297,
    y1: 228.748,
    x2: 74.1076,
    y2: 173.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989CA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989CA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_54707_36542",
    x1: 208.053,
    y1: 88.4297,
    x2: 152.705,
    y2: 104.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989CA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989CA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_54707_36542",
    x1: 152.623,
    y1: 2.96326,
    x2: 114.621,
    y2: 62.6696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989CA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989CA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_54707_36542",
    x1: 179.121,
    y1: 432.74,
    x2: 162.799,
    y2: 377.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989CA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#162936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989CA2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBgTransparent);
export default __webpack_public_path__ + "static/media/menu-bg-transparent.a793202e0c6b48829246bcb3e88817f2.svg";
export { ForwardRef as ReactComponent };